import { CHANNEL_TYPE } from "vue-app/types/enums";

export function updateStateByChannelType(state, channelType) {
  switch (channelType) {
    case CHANNEL_TYPE.SMS: {
      state.availableChannelTypes = [CHANNEL_TYPE.SMS];
      state.editorType = state.messageChannelType || CHANNEL_TYPE.SMS;
      break;
    }
    case CHANNEL_TYPE.EMAIL_AND_SMS: {
      state.availableChannelTypes = [CHANNEL_TYPE.EMAIL, CHANNEL_TYPE.SMS];
      state.editorType = state.messageChannelType || CHANNEL_TYPE.EMAIL;
      break;
    }
    case CHANNEL_TYPE.EMAIL: {
      state.availableChannelTypes = [CHANNEL_TYPE.EMAIL];
      state.editorType = state.messageChannelType || CHANNEL_TYPE.EMAIL;
      break;
    }
    default: {
      state.editorType = state.messageChannelType || CHANNEL_TYPE.EMAIL;
      break;
    }
  }
}

export function mapInitialChannelType(state, channelType) {
  switch (channelType) {
    case CHANNEL_TYPE.SMS: {
      state.messageChannelType = CHANNEL_TYPE.SMS;
      break;
    }
    case CHANNEL_TYPE.EMAIL_AND_SMS:
    case CHANNEL_TYPE.EMAIL:
    default: {
      state.messageChannelType = CHANNEL_TYPE.EMAIL;
      break;
    }
  }
}
